/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityDefinition } from '../models/EntityDefinition';
import type { EntityDefinitionListDto } from '../models/EntityDefinitionListDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class EntityDefinitionService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all entity definitions from the DB.
     * @param orgGuid
     * @returns EntityDefinitionListDto OK
     * @throws ApiError
     */
    public getAllEntityDefinitionDtos(
        orgGuid: string,
    ): CancelablePromise<Array<EntityDefinitionListDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/EntityDefinition/{orgGuid}/GetAllEntityDefinitionDtos',
            path: {
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get a single entity definition by its guid.
     * @param entityDefinitionGuid
     * @param orgGuid
     * @returns EntityDefinition OK
     * @throws ApiError
     */
    public getEntityDefinition(
        entityDefinitionGuid: string,
        orgGuid: string,
    ): CancelablePromise<EntityDefinition> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/EntityDefinition/{orgGuid}/{entityDefinitionGuid}/GetEntityDefinition',
            path: {
                'entityDefinitionGuid': entityDefinitionGuid,
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create a new entity definition
     * @param requestBody
     * @returns EntityDefinition OK
     * @throws ApiError
     */
    public createEntityDefinition(
        requestBody?: EntityDefinition,
    ): CancelablePromise<EntityDefinition> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/EntityDefinition/CreateEntityDefinition',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Update an existing compliance item.
     * @param guid
     * @param requestBody The updated item's details.
     * @returns EntityDefinition OK
     * @throws ApiError
     */
    public updateEntityDefinition(
        guid: string,
        requestBody?: EntityDefinition,
    ): CancelablePromise<EntityDefinition> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/EntityDefinition/{guid}/UpdateEntityDefinition',
            path: {
                'guid': guid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Delete an existing compliance item.
     * @param entityDefinitionGuid The item's guid.
     * @param orgGuid
     * @returns EntityDefinition OK
     * @throws ApiError
     */
    public deleteEntityDefinition(
        entityDefinitionGuid: string,
        orgGuid: string,
    ): CancelablePromise<EntityDefinition> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/EntityDefinition/{orgGuid}/{entityDefinitionGuid}/DeleteEntityDefinition',
            path: {
                'entityDefinitionGuid': entityDefinitionGuid,
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
